import { z } from 'zod';
import { billingAccountSchema } from './credit';
export const userRoleSchema = z.enum(['user', 'admin']);
export const userTierSchema = z.enum(['guest', 'trial', 'subscriber']);
export const userConsentKindSchema = z.enum(['terms', 'privacy', 'marketing', 'data_processing']);
export const userConsentRecordSchema = z.object({
    id: z.string().min(1),
    kind: userConsentKindSchema,
    version: z.string().min(1).nullable(),
    grantedAt: z.string().datetime(),
    withdrawnAt: z.string().datetime().nullable(),
    locale: z.string().min(1).nullable(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const userProfileSchema = z.object({
    id: z.string().min(1),
    email: z.string().email(),
    displayName: z.string().min(1),
    photoUrl: z.string().url().optional(),
    role: userRoleSchema,
    tier: userTierSchema,
    credits: z.number().int().nonnegative(),
    promoCreditsGranted: z.number().int().nonnegative(),
    promoCreditsUsed: z.number().int().nonnegative(),
    topupCredits: z.number().int().nonnegative(),
    wallet: billingAccountSchema,
    trialEndsAt: z.string().datetime().nullable(),
    guestExpiresAt: z.string().datetime().nullable(),
    planId: z.string().min(1).nullable(),
    marketingOptIn: z.boolean(),
    marketingConsentVersion: z.string().min(1).nullable(),
    marketingConsentAt: z.string().datetime().nullable(),
    termsVersionAccepted: z.string().min(1).nullable(),
    termsAcceptedAt: z.string().datetime().nullable(),
    privacyVersionAccepted: z.string().min(1).nullable(),
    privacyAcceptedAt: z.string().datetime().nullable(),
    dataProcessingConsentAt: z.string().datetime().nullable(),
    legalLocale: z.string().min(1).nullable(),
    lastDataExportAt: z.string().datetime().nullable(),
    deletionRequestedAt: z.string().datetime().nullable(),
    deletionScheduledFor: z.string().datetime().nullable(),
    deletedAt: z.string().datetime().nullable(),
    consentHistory: z.array(userConsentRecordSchema),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const userSessionSchema = z.object({
    token: z.string().min(1),
    refreshToken: z.string().min(1).optional(),
    expiresAt: z.number().int().positive(),
    user: userProfileSchema,
});
//# sourceMappingURL=user.js.map